import { render, staticRenderFns } from "./TaxaGeralCard.vue?vue&type=template&id=96e55936"
import script from "./TaxaGeralCard.vue?vue&type=script&lang=ts"
export * from "./TaxaGeralCard.vue?vue&type=script&lang=ts"
import style0 from "./TaxaGeralCard.vue?vue&type=style&index=0&id=96e55936&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports